"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ__FullLoaderPageLoader = exports.Occ__FullLoaderPage = exports.Occ__FullLoader = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ__FullLoader = (0, _styledComponents["default"])('section')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 100vh;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    background-color: var(--color-base-white);\n    position: fixed;\n    z-index: var(--z-index-3);\n    left: 0;\n    top: 0;\n"])));
exports.Occ__FullLoader = Occ__FullLoader;
var Occ__FullLoaderPage = (0, _styledComponents["default"])('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: relative;\n    width: 170px;\n"])));
exports.Occ__FullLoaderPage = Occ__FullLoaderPage;
var Occ__FullLoaderPageLoader = (0, _styledComponents["default"])('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    position: absolute;\n    right: 0;\n    bottom: 60px;\n"])));
exports.Occ__FullLoaderPageLoader = Occ__FullLoaderPageLoader;